"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditRow = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../../../atoms");

var _Table = require("../Table.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const EditRow = ({
  data,
  columns,
  showIndex,
  editText,
  setEditText,
  handleEditSuccess,
  handleEditCancel,
  isEditRow
}) => {
  (0, _react.useEffect)(() => {
    setEditText(data[columns[0].accessor]);
  }, [data]);
  return /*#__PURE__*/_react.default.createElement(_Table.StyledRow, {
    isEditRow: isEditRow
  }, /*#__PURE__*/_react.default.createElement(_Table.StyledCell, {
    colSpan: showIndex ? columns.length + 2 : columns.length + 1
  }, /*#__PURE__*/_react.default.createElement(_Table.StyledEditBox, null, /*#__PURE__*/_react.default.createElement(_atoms.Input, {
    "data-testid": "edit-input",
    className: "input-wrapper",
    inputProps: {
      value: editText,
      className: 'edit-input',
      boxed: true
    },
    onChange: e => setEditText(e.target.value)
  }), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_atoms.ButtonWithIcon, {
    "data-testid": "edit-success-btn",
    className: "success-btn",
    icon: "Checkmark",
    isRoundIcon: true,
    onClick: e => handleEditSuccess(e, data, editText)
  })), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_atoms.ButtonWithIcon, {
    "data-testid": "edit-cancel-btn",
    className: "cancel-btn",
    icon: "Close",
    isRoundIcon: true,
    isPrimary: false,
    onClick: e => handleEditCancel(e, data, editText)
  })))));
};

exports.EditRow = EditRow;
EditRow.propTypes = {
  data: _propTypes.default.object,
  columns: _propTypes.default.array,
  showIndex: _propTypes.default.bool,
  editText: _propTypes.default.string,
  setEditText: _propTypes.default.func,
  handleEditSuccess: _propTypes.default.func,
  handleEditCancel: _propTypes.default.func,
  isEditRow: _propTypes.default.bool
};